import React from 'react';

export default function SelectItem({ item, setStateHandler }) {
  const { name, id, selected } = item;

  const handleClick = (event, id) => {
    if (event.defaultPrevented) return;
    event.preventDefault();
    event.stopPropagation();

    setStateHandler((prevState) => {
      const newState = [...prevState];
      const updatedItemIndex = newState.findIndex((item) => item.id === id);

      newState[updatedItemIndex] = {
        ...newState[updatedItemIndex],
        selected: !newState[updatedItemIndex].selected
      };

      return newState;
    });
  };

  return (
    <li onClick={(event) => handleClick(event, id)}>
      <label className="select-dropdown__checkbox-container">
        {name}
        <input
          onChange={() => null}
          type="checkbox"
          checked={selected ? 'checked' : ''}
        ></input>
        <span className="select-dropdown__checkmark"></span>
      </label>
    </li>
  );
}
